import(/* webpackMode: "eager" */ "/app/app/(public)/home/ui/home.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js")